import { notifications } from "@mantine/notifications";

/**
 * AD-188: a failed save shown where it belongs. A 422's messages go under their
 * fields; anything else (403, 429, 500, no connection) becomes a notification,
 * so a form never just stops its spinner and says nothing.
 */
export const showServerErrors = (form, error, fallbackMessage) => {
    const fieldErrors = Object.fromEntries(
        Object.entries(error?.response?.data?.errors || {}).map(([field, messages]) => [field, messages?.[0]])
    );

    if (Object.keys(fieldErrors).length > 0) {
        form.setErrors(fieldErrors);
        return;
    }

    notifications.show({ color: 'red', message: error?.response?.data?.message || fallbackMessage });
};
